export * from './footer.module';

export * from './footer-basic/footer-basic.component';
export * from './footer-main/footer-main.component';
